import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import FilterDropdown from "./filterComponent";
import ProgressBarChart from "../../dashboard/widgets/progressChart";
import { fetchProgressPerNmscBar } from "../../../actions/dashboardAction";
import '../index.css';
import { AUTO_DEFAULT_FILTER } from "../../../AppConstant";

const ProgressPerNMSC = (props) => {
    var I18n = require("react-redux-i18n").I18n;
    const { dispatch, dealerOperations } = props;
    const [data, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [filterStatus, setFilterStatus] = useState("Started");
    const [filterChangeCount, setFilterChangeCount] = useState(0);

    /** Handler for filter */
    const handleApplyFilters = (filters) => {
        setFilterStatus(filters[0]);
    };

    /** Memoize filtered data for performance and sorted */ 
    const filteredData = useMemo(() =>
        data?.map(item => ({
            nmscCode: item.nmscCode,
            value: filterStatus === "Started" ? item.startedPercentage : item.passedPercentage
        })).sort((a, b) =>  b.value - a.value), [data, filterStatus]
    );

    /** Handler for API success callback */
    const onSuccess = (response) => setData(response);
    /** Handler for API failure callback */
    const onFailure = (error) => console.error("❌ Error while fetching list of video", error);

    const fetchProgressBarData = () => {
        try {
            if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
                return;
            }

            const toolBoxList = props.toolboxByType?.toolboxByType;
            const cycleList = props.cycleDataList;

            if (!toolBoxList || toolBoxList.length === 0 || !cycleList || cycleList.length === 0) {
                console.warn("Required data is not ready yet.");
                return;
            }

            const initialToolBoxId = toolBoxList[toolBoxList.length - 1];
            const initialCycle = cycleList[cycleList.length - 1];
            const activeProgram = props.existingProps.userMdl.activeProgram;

            if (!initialCycle?.cycle) {
                console.warn("Initial cycle format is missing.");
                return;
            }
            const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
            const nmscCode = props.existingProps.userMdl.nmsc;
            const searchedFilters = props.searchFilters.nmscCode?.filter(item => item !== null && item !== undefined).map(item => item.value || item.name || item.code || item);
            const data = {
                "userNmscCode": props.existingProps.userMdl.nmsc,
                "userLangCode": props.existingProps.userMdl.lang,
                "programList": [props.existingProps.userMdl.activeProgram],
                "nmscCode": props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
                "brand": props.existingProps.brandFilter,
                "country": props.existingProps.countryFilter,
                "region": props.existingProps.regionFilter,
                "userId": props.existingProps.userMdl.username,
                "businessArea": props.existingProps.userMdl.businessAreaKey,
                "toolboxIDList": (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)],
                "startDate": props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate,
                "endDate": props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate,
                "nmscDropdown": searchedFilters,
                "dealerOperations": dealerOperations?.length > 0 ? dealerOperations : (AUTO_DEFAULT_FILTER[activeProgram] || ['All'])
            }
            dispatch(fetchProgressPerNmscBar(onSuccess, onFailure, data))

        } catch (error) {
            console.error("Error fetching progress bar data:", error);
        }
    }


    // Track filter changes to detect when fresh data arrives
    useEffect(() => {
        setFilterChangeCount(prev => prev + 1);
    }, [props.searchFilters?.nmscCode]);

    useEffect(() => {
        const toolBoxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;
        
        // Only make API call after at least one filter change (skip initial old data)
        // This ensures we wait for fresh data before making the call
        if (toolBoxReady && cycleReady && filterChangeCount > 1 && !hasFetched) {
            fetchProgressBarData();
            setHasFetched(true);
        }
    }, [props.toolboxByType?.toolboxByType, props.cycleDataList, filterChangeCount, hasFetched]);

    // Reset hasFetched when filters change to allow new API call
    useEffect(() => {
        if (filterChangeCount > 2) { // Reset after second change
            setHasFetched(false);
        }
    }, [filterChangeCount]);

    return (
        <div className='toolboxImplNasCss'>
            <div className={"large-widget-header left-align-header widget-header-" + props.theme.name} title={I18n.t('dashboardHeaders.ProgressPerNMSCElement')}>
                {I18n.t('dashboard.progressPerNMSC')}
                <FilterDropdown
                    options={['Started', 'Passed']}
                    onApply={handleApplyFilters}
                    defaultSelected={['Started']}
                    theme="dark"
                    icon="filter"
                    customClassName="widget-filter-menu-score-per-nmsc"
                />
            </div>
            <div style={{ overflowY: "scroll", height: "580px", position: "relative" }}>
                <div style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#fff", // important to avoid transparent background while scrolling
                    zIndex: 1,
                    padding: "10px 15px",
                    borderBottom: "1px solid #ccc",
                }}>
                    <p style={{
                        display: 'inline-block',
                        margin: 0,
                        marginRight: '13px',
                        border: "1px solid rgb(110 98 98)",
                        backgroundColor: "rgb(237 180 180)",
                        width: '83px',
                        paddingInline: '14px',
                        fontFamily: 'Arial, Helvetica, sans-serif',
                        fontSize: '13.5px',
                    }}>
                        {filterStatus}
                    </p></div>
                <div style={{ paddingTop: "10px" }}>
                    <ProgressBarChart data={filteredData || []} />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer,
        searchFilters: state.dashboardReducer.filters
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(ProgressPerNMSC)));

